// extracted by mini-css-extract-plugin
export default {"root":"dtQaxv302n4xViSy9Q5P","th":"fhNyebAlHDdvG2dzqz26","sunday":"Acr3fUI00p0GZXIQFVVl","placeHolderShimmer":"mixBHJmWaubbQhPxpM71"};